/* Phone/tablet style picker: reuse OptionSelectors, gallery and the original form. */
(function () {
  if (window.odgStylePickerBound) return;
  window.odgStylePickerBound = true;
  var media = window.matchMedia('(max-width: 991px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instances = new Map();
  function pruneDetached() {
    instances.forEach(function (dispose, product) { if (!product.isConnected) dispose(); });
  }
  window.odgSyncStylePicker = function (product, variant) {
    var dialog = product.querySelector('[data-odg-style-dialog]');
    if (!dialog) return;
    product.querySelectorAll('[data-odg-variant]').forEach(function (input) {
      input.checked = !!variant && String(variant.id) === input.value;
    });
    if (!variant) return;
    var selected = product.querySelector('[data-odg-variant]:checked');
    var image = dialog.querySelector('[data-odg-style-image]');
    if (image && selected && selected.dataset.image) {
      if (image.getAttribute('src') !== selected.dataset.image) image.src = selected.dataset.image;
      image.alt = variant.title;
      var imageButton = dialog.querySelector('[data-odg-style-image-open]');
      if (imageButton) imageButton.setAttribute('aria-label', 'View image: ' + variant.title);
    }
    var title = dialog.querySelector('[data-odg-style-title]');
    if (title) title.textContent = variant.title + (!variant.available ? ' · ' + dialog.dataset.soldOutLabel : '');
    var price = dialog.querySelector('[data-odg-style-price]');
    var sourcePrice = product.querySelector('.odg-product-summary > .product__price');
    if (price && sourcePrice) {
      price.replaceChildren();
      sourcePrice.querySelectorAll('.js-price-default, .js-price-new, .js-price-old').forEach(function (source) {
        if (source.classList.contains('d-none')) return;
        var span = document.createElement('span');
        if (source.classList.contains('js-price-old')) span.className = 'odg-style-was';
        span.innerHTML = source.innerHTML;
        price.appendChild(span);
      });
    }
    var offer = dialog.querySelector('[data-odg-style-offer]');
    if (offer) {
      offer.replaceChildren();
      var sourceOffer = product.querySelector('.odg-product-summary .js-odg-offer-variant[data-variant-id="' + variant.id + '"]');
      var hasOffer = variant.compare_at_price > variant.price && variant.compare_at_price > 0 && sourceOffer;
      if (hasOffer) {
        var badge = document.createElement('div');
        badge.className = 'discount-box';
        var text = document.createElement('span');
        text.className = 'discount-text';
        var drawerOffer = sourceOffer.getAttribute('data-odg-drawer-offer');
        text.innerHTML = drawerOffer !== null ? drawerOffer : sourceOffer.innerHTML;
        badge.appendChild(text);
        offer.appendChild(badge);
      } else {
        var tax = document.createElement('span');
        tax.className = 'tax-included';
        var sourceTax = product.querySelector('.odg-product-summary .tax-included');
        tax.textContent = sourceTax ? sourceTax.textContent : 'Tax Included';
        offer.appendChild(tax);
      }
    }
    (variant.options || [variant.option1, variant.option2, variant.option3]).forEach(function (value, index) {
      if (value == null) return;
      var optionName = 'option' + (index + 1);
      product.querySelectorAll('.product__options [data-option="' + optionName + '"]').forEach(function (group) {
        if (group.matches('select')) group.value = value;
        group.querySelectorAll('.js-product-color').forEach(function (control) {
          control.parentElement.classList.toggle('active', control.dataset.value === value);
        });
      });
      product.querySelectorAll('.js-product-color-value[data-option="' + optionName + '"]').forEach(function (label) { label.textContent = value; });
    });
  };

  function initialize(product) {
    var dialog = product.querySelector('[data-odg-style-dialog]');
    var selectors = product.odgStyleSelectors;
    if (!dialog || !selectors || dialog.dataset.odgInitialized || !dialog.querySelector('[data-odg-style-strip]') || typeof dialog.showModal !== 'function') return;
    var dataNode = document.getElementById('ProductJson' + product.dataset.productId);
    if (!dataNode) return;
    var data;
    try {
      var dataSource = dataNode.textContent;
      var cachedData = dataNode.odgProductData;
      data = cachedData && cachedData.source === dataSource ? cachedData.value : JSON.parse(dataSource);
      dataNode.odgProductData = { source: dataSource, value: data };
    } catch (_) { return; }
    var variantById = new Map();
    data.variants.forEach(function (variant) { variantById.set(String(variant.id), variant); });
    var disposed = false;
    var globalListeners = [];
    var motionTimers = new Set();
    var cartObserver = null;
    function listenGlobal(target, type, callback, options) {
      target.addEventListener(type, callback, options);
      globalListeners.push(function () { target.removeEventListener(type, callback, options); });
    }
    dialog.dataset.odgInitialized = 'true';
    dialog.classList.add('odg-style-ready');
    var opener = null;
    var keyboardOpened = false;
    var animation = null;
    var closing = false;
    var handingOff = false;
    var scrollY = 0;
    var scrollX = 0;
    var lockHeld = false;
    var savedBody = null;
    var lastTouchY = 0;
    var pendingInert = [];
    var form = dialog.querySelector('form');
    var status = dialog.querySelector('[data-odg-style-status]');
    var closeButton = dialog.querySelector('[data-odg-style-close]');
    var triggers = dialog.querySelectorAll('[data-odg-style-open]');
    var cartDrawer = document.querySelector('.js-canvas-cart');
    var placeholder = document.createElement('div');
    placeholder.className = 'odg-style-placeholder';
    placeholder.hidden = true;
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.inert = true;
    dialog.before(placeholder);
    // Keep display-only content in the document instead of pulling it into the modal.
    var background = document.createElement('div');
    background.className = 'odg-style-background odg-style-ready';
    background.tabIndex = -1;
    background.hidden = true;
    dialog.before(background);
    // Reserve only the purchase form's original slot, AFTER the display-only background.
    background.after(placeholder);
    var displayNodes = Array.from(form.children).filter(function (node) {
      return node.matches('.product__tag, .odg-product-summary, .product__description, .product__promo-bar, .odg-style-strip') && (node.matches('.odg-style-strip') || !node.querySelector('input[name], select[name], textarea[name]'));
    }).map(function (node) {
      var home = document.createElement('span');
      home.hidden = true;
      node.before(home);
      return { node: node, home: home };
    });
    function placeBackground() {
      displayNodes.forEach(function (entry) {
        if (media.matches) background.appendChild(entry.node);
        else entry.home.after(entry.node);
      });
      background.hidden = !media.matches;
    }
    placeBackground();
    // Read-only appearance only: never clone a form, control, SDK component, ID, or event hook.
    var frozenProperties = 'display position box-sizing width height min-width max-width min-height max-height margin padding border border-radius background color font-family font-size font-weight font-style line-height letter-spacing text-align text-transform text-decoration white-space vertical-align align-items align-content justify-content flex-direction flex-wrap flex-grow flex-shrink flex-basis gap row-gap column-gap overflow top right bottom left transform opacity box-shadow'.split(' ');
    function freezeAppearance(node) {
      if (node.nodeType === 3) return document.createTextNode(node.nodeValue);
      if (node.nodeType !== 1 || node.hidden) return null;
      var tag = node.tagName.toLowerCase();
      if (/^(script|style|template|link|noscript)$/.test(tag) || node.matches('.odg-style-sr, .odg-style-drawer-head, .odg-style-drawer-body')) return null;
      var style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return null;
      var rect = node.getBoundingClientRect();
      if ((!rect.width || !rect.height) && style.display !== 'contents') return null;
      var copy = document.createElement(tag === 'img' && node.complete && node.naturalWidth ? 'img' : 'div');
      copy.className = String(node.className || '').split(/\s+/).filter(function (name) { return name && !/^(js-|shopify-)/.test(name); }).join(' ');
      frozenProperties.forEach(function (property) { copy.style.setProperty(property, style.getPropertyValue(property)); });
      var walletRegion = node.matches('.shopify-payment-button, [data-shopify="payment-button"]') || tag.indexOf('shopify-') === 0 || (node.matches('.product__buy-now') && node.querySelector('.shopify-payment-button, shopify-accelerated-checkout'));
      if (walletRegion && rect.width && rect.height) {
        // Closed-shadow wallets cannot be copied. Keep only a same-size ordinary visual block.
        copy.className = 'odg-style-static-payment';
        copy.style.boxSizing = 'border-box';
        copy.style.width = rect.width + 'px';
        copy.style.height = rect.height + 'px';
        var face = document.createElement('div');
        var fallback = node.querySelector('button');
        face.style.cssText = 'width:100%;height:100%;border-radius:4px;background:#f5f5f5;color:#666;display:flex;align-items:center;justify-content:center;';
        face.textContent = fallback ? fallback.textContent.trim() : '';
        copy.appendChild(face);
      } else if (tag === 'img') {
        if (node.complete && node.naturalWidth) { copy.src = node.currentSrc || node.src; copy.alt = ''; }
      } else if (/^(input|textarea|select)$/.test(tag)) {
        copy.textContent = tag === 'select' ? Array.from(node.selectedOptions).map(function (option) { return option.textContent; }).join(' ') : node.value;
      } else {
        Array.from(node.childNodes).forEach(function (child) {
          var visual = freezeAppearance(child);
          if (visual) copy.appendChild(visual);
        });
      }
      return copy;
    }
    function freezeFooter() {
      var visual = document.createElement('div');
      visual.className = 'odg-style-frozen';
      Array.from(form.children).forEach(function (node) {
        var copy = freezeAppearance(node);
        if (copy) visual.appendChild(copy);
      });
      placeholder.replaceChildren(visual);
    }
    function restoreOpener() {
      var target = keyboardOpened ? opener : background;
      if (target && target.isConnected) target.focus({ preventScroll: true });
      keepPagePosition();
    }

    function keepPagePosition() {
      if (lockHeld) return;
      var root = document.documentElement;
      var previousBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(scrollX, scrollY);
      root.style.scrollBehavior = previousBehavior;
    }
    function lockPage() {
      if (lockHeld) return;
      scrollY = window.scrollY;
      scrollX = window.scrollX;
      var body = document.body;
      var gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      var keepGutter = gap > 0 && window.CSS && window.CSS.supports && window.CSS.supports('scrollbar-gutter', 'stable');
      if (keepGutter) document.documentElement.classList.add('odg-style-gutter');
      var padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
      savedBody = {};
      ['overflow', 'paddingRight'].forEach(function (key) { savedBody[key] = body.style[key]; });
      body.style.overflow = 'hidden';
      if (gap && !keepGutter) body.style.paddingRight = padding + gap + 'px';
      lockHeld = true;
      document.documentElement.classList.add('odg-style-lock');
    }
    function unlockPage() {
      if (!lockHeld) return;
      Object.keys(savedBody).forEach(function (key) { document.body.style[key] = savedBody[key]; });
      lockHeld = false;
      savedBody = null;
      document.documentElement.classList.remove('odg-style-lock', 'odg-style-gutter');
      keepPagePosition();
    }
    listenGlobal(document, 'touchstart', function (event) {
      if (lockHeld && event.touches.length === 1) lastTouchY = event.touches[0].clientY;
    }, { passive: true });
    listenGlobal(document, 'touchmove', function (event) {
      if (!lockHeld || event.touches.length !== 1) return;
      if (imageLayer && imageLayer.open && imageRoot.contains(event.target)) return;
      var y = event.touches[0].clientY;
      var delta = y - lastTouchY;
      lastTouchY = y;
      var boundary = cartLayer && cartLayer.open ? cartDrawer : dialog.matches(':modal') ? dialog : cartDrawer;
      var node = event.target.nodeType === 1 ? event.target : event.target.parentElement;
      if (boundary && boundary.contains(node)) {
        while (node && boundary.contains(node)) {
          var overflow = getComputedStyle(node).overflowY;
          if (/auto|scroll/.test(overflow) && node.scrollHeight > node.clientHeight + 1) {
            if ((delta < 0 && node.scrollTop + node.clientHeight < node.scrollHeight - 1) || (delta > 0 && node.scrollTop > 0)) return;
          }
          node = node.parentElement;
        }
      }
      if (event.cancelable) event.preventDefault();
    }, { passive: false });
    var imageLayer = null;
    var imageHome = null;
    var imageRoot = null;
    var imageTrigger = dialog.querySelector('[data-odg-style-image-open]');
    function imagePath(source) {
      try { return new URL(source, window.location.href).pathname.replace(/_(?:\d+x\d*|x\d+)(?=\.[^.]+$)/i, ''); }
      catch (_) { return source; }
    }
    var activeImageViewer = null;
    var imageMetadata = null;
    var imageDimensions = null;
    function finishImageViewer(viewer) {
      if (viewer && activeImageViewer !== viewer) return;
      var layer = imageLayer;
      var root = imageRoot;
      var home = imageHome;
      activeImageViewer = null;
      imageLayer = null;
      imageRoot = null;
      imageHome = null;
      // Close the owned top-layer blocker BEFORE moving its focused content out.
      if (layer && layer.open) { try { layer.close(); } catch (_) {} }
      if (root) {
        root.setAttribute('aria-hidden', 'true');
        root.classList.remove('pswp--open', 'pswp--visible');
        if (home && home.isConnected) home.after(root);
        else document.body.appendChild(root);
      }
      if (layer) layer.remove();
      if (home) home.remove();
      if (disposed) return;
      if (!dialog.matches(':modal')) {
        if (!(cartLayer && cartLayer.open)) { unlockPage(); restoreOpener(); }
        return;
      }
      // Let native modal inertness settle before restoring focus inside the still-open picker.
      requestAnimationFrame(function () {
        if (imageLayer || (cartLayer && cartLayer.open) || !dialog.matches(':modal')) return;
        dialog.focus({ preventScroll: true });
        if (imageTrigger && imageTrigger.isConnected) imageTrigger.focus({ preventScroll: true });
      });
    }
    function openSelectedImage() {
      if (disposed || !dialog.matches(':modal') || dialog.classList.contains('is-cart-pending') || activeImageViewer) return;
      var gallery = document.querySelector('.js-product-mobile-gallery[data-product-id="' + product.dataset.productId + '"]');
      var root = document.querySelector('.pswp[role="dialog"]');
      if (!gallery || !root || root.getAttribute('aria-hidden') === 'false' || typeof window.PhotoSwipe !== 'function' || !window.PhotoSwipeUI_Default) return;
      var variant = variantById.get(String(selectors.variantIdField.value));
      var source = variant && variant.featured_image ? variant.featured_image.src : data.featured_image;
      var links = Array.from(gallery.querySelectorAll('a')).filter(function (link) { return !link.closest('.slick-cloned') && link.querySelector('img'); });
      var position = variant && variant.featured_image ? Number(variant.featured_image.position || 1) - 1 : 0;
      var link = links.find(function (item) { return source && imagePath(item.href) === imagePath(source); }) || links[position] || links[0];
      if (!link) return;
      if (!imageMetadata) {
        var metadataNode = dialog.querySelector('[data-odg-image-metadata]');
        try { imageMetadata = metadataNode ? JSON.parse(metadataNode.textContent) : []; } catch (_) { imageMetadata = []; }
        if (!Array.isArray(imageMetadata)) imageMetadata = [];
        imageDimensions = new Map();
        imageMetadata.forEach(function (item) { imageDimensions.set(imagePath(item.src), item); });
      }
      var items = links.map(function (anchor, index) {
        var info = imageDimensions.get(imagePath(anchor.href)) || imageMetadata[index] || {};
        var thumb = anchor.querySelector('img');
        return { src: anchor.href, title: anchor.getAttribute('title') || '',
          w: Number(info.w) || (thumb && thumb.naturalWidth) || 0,
          h: Number(info.h) || (thumb && thumb.naturalHeight) || 0 };
      });
      var selectedIndex = links.indexOf(link);
      if (!items[selectedIndex] || !items[selectedIndex].w || !items[selectedIndex].h) return;
      if (!imageLayer) {
        imageRoot = root;
        imageHome = document.createElement('span');
        imageHome.hidden = true;
        imageHome.setAttribute('aria-hidden', 'true');
        root.before(imageHome);
        imageLayer = document.createElement('dialog');
        imageLayer.className = 'odg-image-layer';
        imageLayer.setAttribute('autofocus', '');
        imageLayer.addEventListener('cancel', function (event) {
          event.preventDefault();
          if (activeImageViewer) activeImageViewer.close();
          else finishImageViewer(null);
        });
        document.body.appendChild(imageLayer);
      }
      var image = dialog.querySelector('[data-odg-style-image]');
      if (image) imageLayer.setAttribute('aria-label', image.alt);
      imageLayer.appendChild(root);
      try { imageLayer.showModal(); }
      catch (_) { finishImageViewer(null); return; }
      var options = { index: selectedIndex, galleryUID: (window.jQuery && window.jQuery(link).data('gid')) || product.dataset.productId };
      if (reduced.matches) { options.showAnimationDuration = 0; options.hideAnimationDuration = 0; }
      var viewer;
      try {
        viewer = new window.PhotoSwipe(root, window.PhotoSwipeUI_Default, items, options);
        activeImageViewer = viewer;
        // Dimensions and listeners exist BEFORE init, including for the initially selected item.
        viewer.listen('gettingData', function (index, item) {
          var info = imageDimensions.get(imagePath(item.src));
          if (info && (!item.w || !item.h)) { item.w = Number(info.w); item.h = Number(info.h); }
        });
        viewer.listen('destroy', function () {
          // PhotoSwipe emits destroy before finishing its own DOM/event cleanup.
          Promise.resolve().then(function () { finishImageViewer(viewer); });
        });
        viewer.init();
      } catch (_) {
        try { if (viewer && viewer.destroy) viewer.destroy(); } catch (_) {}
        finishImageViewer(viewer);
      }
    }
    var cartLayer = null;
    var cartHome = null;
    var cartClosing = false;
    function waitForCartMotion(cart, done) {
      var content = cart && cart.querySelector('.canvas-cart__content');
      var completed = false;
      var timer;
      function finish() {
        if (completed) return;
        completed = true;
        clearTimeout(timer);
        motionTimers.delete(timer);
        if (!disposed) done();
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (reduced.matches || !content) { finish(); return; }
          var running = content.getAnimations ? content.getAnimations() : [];
          if (running.length) Promise.all(running.map(function (item) { return item.finished.catch(function () {}); })).then(finish);
          else if (content.getAnimations) { finish(); return; }
          var durations = getComputedStyle(content).transitionDuration.split(',');
          var duration = durations.reduce(function (max, value) { return Math.max(max, parseFloat(value) * (value.indexOf('ms') > -1 ? 1 : 1000)); }, 0);
          if (disposed) return;
          timer = setTimeout(finish, Math.min(1200, duration + 80));
          motionTimers.add(timer);
        });
      });
    }
    function raiseOriginalCart(cart) {
      if (!cartLayer) {
        cartHome = document.createElement('span');
        cartHome.hidden = true;
        cartHome.setAttribute('aria-hidden', 'true');
        cart.before(cartHome);
        cartLayer = document.createElement('dialog');
        cartLayer.className = 'odg-cart-layer';
        cartLayer.setAttribute('autofocus', '');
        cartLayer.addEventListener('cancel', function (event) {
          event.preventDefault();
          var close = cart.querySelector('a.js-close-canvas-cart, button.js-close-canvas-cart');
          if (close) close.click();
          else cart.classList.remove('active');
        });
        document.body.appendChild(cartLayer);
      }
      var heading = cart.querySelector('.canvas-cart__h3');
      if (heading) cartLayer.setAttribute('aria-label', heading.textContent.trim());
      cartLayer.appendChild(cart);
      try {
        if (!cartLayer.open) cartLayer.showModal();
        cartLayer.focus({ preventScroll: true });
        return true;
      } catch (_) {
        cartHome.after(cart);
        return false;
      }
    }
    function finishCartClose() {
      if (cartClosing) return;
      cartClosing = true;
      waitForCartMotion(cartDrawer, function () {
        cartClosing = false;
        if (cartDrawer.classList.contains('active')) return;
        if (cartHome) cartHome.after(cartDrawer);
        if (cartLayer && cartLayer.open) cartLayer.close();
        cartDrawer.classList.remove('odg-style-cart-handoff');
        handingOff = false;
        if (dialog.matches(':modal')) {
          dialog.classList.remove('is-cart-covered', 'is-handoff');
          dialog.focus({ preventScroll: true });
        } else {
          unlockPage();
          restoreOpener();
        }
      });
    }
    if (cartDrawer) {
      cartObserver = new MutationObserver(function () {
        if (!disposed && lockHeld && !cartDrawer.classList.contains('active') && ((cartLayer && cartLayer.open) || !dialog.matches(':modal'))) finishCartClose();
      });
      cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    function restore() {
      if (dialog.matches(':modal') || !dialog.classList.contains('is-drawer')) return;
      if (animation) { animation.cancel(); animation = null; }
      closing = false;
      dialog.classList.remove('is-drawer');
      dialog.setAttribute('role', 'presentation');
      dialog.removeAttribute('aria-modal');
      dialog.removeAttribute('aria-labelledby');
      triggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
      dialog.removeAttribute('autofocus');
      // Restore the ordinary container without show() auto-focusing its quantity input.
      dialog.setAttribute('open', '');
      placeholder.hidden = true;
      placeholder.replaceChildren();
      if (!handingOff && !(imageLayer && imageLayer.open)) {
        unlockPage();
        restoreOpener();
      }
      dialog.classList.remove('is-closing', 'is-handoff', 'is-cart-covered');
    }
    function closeDrawer(immediate) {
      if (!dialog.matches(':modal') || (closing && !immediate)) return;
      var from = getComputedStyle(dialog).transform;
      if (animation) { animation.cancel(); animation = null; }
      closing = true;
      dialog.classList.add('is-closing');
      function finish() {
        if (closing && dialog.matches(':modal')) { dialog.close(); restore(); }
      }
      if (immediate || reduced.matches || !dialog.animate) { finish(); return; }
      animation = dialog.animate([
        { transform: from === 'none' ? 'translateY(0)' : from },
        { transform: 'translateY(100%)' }
      ], { duration: 170, easing: 'cubic-bezier(.32,.72,0,1)', fill: 'forwards' });
      animation.finished.then(finish, function () {});
    }
    function openDrawer(trigger, fromKeyboard) {
      if (disposed || !media.matches || dialog.matches(':modal')) return;
      handingOff = false;
      opener = trigger || product.querySelector('[data-odg-style-open]');
      keyboardOpened = !!fromKeyboard;
      var formStyle = getComputedStyle(form);
      placeholder.style.height = form.getBoundingClientRect().height + 'px';
      placeholder.style.marginTop = formStyle.marginTop;
      placeholder.style.marginBottom = formStyle.marginBottom;
      freezeFooter();
      lockPage();
      dialog.close();
      placeholder.hidden = false;
      dialog.classList.add('is-drawer');
      dialog.classList.remove('is-closing', 'is-handoff', 'is-cart-covered');
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', 'odg-style-title-' + product.dataset.productId);
      dialog.setAttribute('autofocus', '');
      try { dialog.showModal(); } catch (_) { restore(); return; }
      triggers.forEach(function (item) { item.setAttribute('aria-expanded', 'true'); });
      dialog.focus({ preventScroll: true });
      if (!reduced.matches && dialog.animate) {
        animation = dialog.animate([{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], { duration: 300, easing: 'cubic-bezier(.32,.72,0,1)' });
      }
    }
    function clearPending(button) {
      button.removeAttribute('data-odg-cart-pending');
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
      dialog.classList.remove('is-cart-pending');
      pendingInert.forEach(function (entry) { entry.node.inert = entry.value; });
      pendingInert = [];
    }
    dialog.odgCartPending = function () {
      if (disposed) return;
      dialog.classList.add('is-cart-pending');
      pendingInert = [];
      dialog.querySelectorAll('.odg-style-drawer-body, .product__quantity, .product__buy-now').forEach(function (node) {
        pendingInert.push({ node: node, value: node.inert });
        node.inert = true;
      });
    };
    dialog.odgCartError = clearPending;
    dialog.odgCartReady = function (cart, button) {
      if (disposed) {
        clearPending(button);
        if (cart) cart.classList.add('active');
        return;
      }
      if (!cart) { clearPending(button); return; }
      lockPage();
      var raised = raiseOriginalCart(cart);
      var content = cart.querySelector('.canvas-cart__content');
      // Commit the original closed-cart transform before activating its normal entrance.
      if (content && !cart.classList.contains('active')) content.getBoundingClientRect();
      handingOff = true;
      if (raised && dialog.matches(':modal')) dialog.classList.add('is-cart-covered');
      cart.classList.add('active');
      if (!raised) {
        dialog.classList.add('is-handoff');
        closeDrawer(true);
      }
      waitForCartMotion(cart, function () {
        if (!cart.classList.contains('active')) {
          clearPending(button);
          return;
        }
        // The real cart has animated visibly above the selector; retire only the covered selector.
        dialog.classList.add('is-handoff');
        closeDrawer(true);
        clearPending(button);
        if (cartLayer && cartLayer.open) cartLayer.focus({ preventScroll: true });
      });
    };
    listenGlobal(dialog, 'close', restore);
    listenGlobal(dialog, 'cancel', function (event) { event.preventDefault(); closeDrawer(false); });
    listenGlobal(product, 'click', function (event) {
      if (disposed) return;
      if (event.target.closest('[data-odg-style-image-open]')) { openSelectedImage(); return; }
      var clickedThumb = event.target.closest('.odg-style-thumb');
      if (media.matches && styleStrip && clickedThumb && styleStrip.contains(clickedThumb)) {
        var checkedInput = clickedThumb.querySelector('[data-odg-variant]');
        if (checkedInput && checkedInput.checked) centerChosenThumb(checkedInput);
      }
      if (media.matches && event.target.closest('.js-product-out-of-stock a')) { event.preventDefault(); return; }
      if (event.target.closest('[data-odg-style-close]')) { closeDrawer(false); return; }
      var strip = event.target.closest('[data-odg-style-strip]');
      if (strip && !event.target.closest('.odg-style-thumb')) { openDrawer(event.target.closest('button'), event.detail === 0); return; }
      if (event.target === dialog && dialog.matches(':modal')) {
        var rect = dialog.getBoundingClientRect();
        if (event.clientY < rect.top || event.clientY > rect.bottom || event.clientX < rect.left || event.clientX > rect.right) closeDrawer(false);
      }
    });
    var styleStrip = product.querySelector('.odg-style-thumbs');
    var centerFrame = 0;
    var centerTarget = null;
    var centerToken = 0;
    var centerTimer = 0;
    function centerChosenThumb(input) {
      if (disposed || !styleStrip || !styleStrip.contains(input)) return;
      var token = ++centerToken;
      if (centerFrame) { cancelAnimationFrame(centerFrame); centerFrame = 0; }
      if (centerTimer) { clearTimeout(centerTimer); centerTimer = 0; }
      if (centerTarget !== null) {
        var currentLeft = styleStrip.scrollLeft;
        if (Math.abs(currentLeft - centerTarget) > 1) styleStrip.scrollTo({ left: currentLeft, behavior: 'instant' });
        centerTarget = null;
      }
      var thumb = input.closest('.odg-style-thumb');
      if (!thumb) return;
      function measure() {
        if (disposed || token !== centerToken) return;
        centerFrame = requestAnimationFrame(function () {
          centerFrame = 0;
          if (token !== centerToken || !media.matches || !input.checked || !styleStrip.isConnected) return;
          var width = styleStrip.clientWidth;
          var maxLeft = Math.max(0, styleStrip.scrollWidth - width);
          if (!width || maxLeft < 1) return;
          var stripRect = styleStrip.getBoundingClientRect();
          var thumbRect = thumb.getBoundingClientRect();
          var target = styleStrip.scrollLeft + thumbRect.left + thumbRect.width / 2 - stripRect.left - styleStrip.clientLeft - width / 2;
          target = Math.max(0, Math.min(maxLeft, target));
          if (Math.abs(target - styleStrip.scrollLeft) < 1) return;
          centerTarget = target;
          styleStrip.scrollTo({ left: target, behavior: reduced.matches ? 'instant' : 'smooth' });
        });
      }
      if (reduced.matches) { measure(); return; }
      if (thumb.getAnimations) {
        var transitions = thumb.getAnimations().filter(function (motion) { return motion.transitionProperty === 'flex-basis'; });
        if (transitions.length) {
          Promise.all(transitions.map(function (motion) { return motion.finished.catch(function () {}); })).then(measure);
        } else measure();
      } else centerTimer = setTimeout(measure, 240);
    }
    listenGlobal(product, 'change', function (event) {
      if (disposed) return;
      var input = event.target.closest('[data-odg-variant]');
      if (!input || !media.matches) return;
      selectors.selectVariant(input.value);
      centerChosenThumb(input);
      if (status) {
        status.textContent = '';
        requestAnimationFrame(function () {
          if (disposed) return;
          var selected = variantById.get(String(input.value));
          if (selected) status.textContent = selected.title + (!selected.available ? ' · ' + dialog.dataset.soldOutLabel : '');
        });
      }
    });
    listenGlobal(media, 'change', function () {
      if (!media.matches && dialog.matches(':modal')) closeDrawer(true);
      placeBackground();
    });
    function dispose() {
      if (disposed) return;
      disposed = true;
      instances.delete(product);
      globalListeners.forEach(function (remove) { remove(); });
      globalListeners = [];
      if (cartObserver) cartObserver.disconnect();
      motionTimers.forEach(function (timer) { clearTimeout(timer); });
      motionTimers.clear();
      ++centerToken;
      if (centerFrame) { cancelAnimationFrame(centerFrame); centerFrame = 0; }
      if (centerTimer) { clearTimeout(centerTimer); centerTimer = 0; }
      if (activeImageViewer) {
        // Keep PhotoSwipe's real destroy/return order; do not tear out its active root.
        try { activeImageViewer.close(); } catch (_) { finishImageViewer(activeImageViewer); }
      }
      closeDrawer(true);
      if (animation) { animation.cancel(); animation = null; }
      pendingInert.forEach(function (entry) { entry.node.inert = entry.value; });
      pendingInert = [];
      var pendingButton = dialog.querySelector('[data-odg-cart-pending]');
      if (pendingButton) clearPending(pendingButton);
      if (cartLayer) {
        var ownedCart = cartDrawer && cartDrawer.parentElement === cartLayer;
        if (cartLayer.open) cartLayer.close();
        if (ownedCart) {
          if (cartHome && cartHome.isConnected) cartHome.after(cartDrawer);
          else document.body.appendChild(cartDrawer);
          cartDrawer.classList.remove('odg-style-cart-handoff');
        }
        cartLayer.remove();
        cartLayer = null;
      }
      if (cartHome) { cartHome.remove(); cartHome = null; }
      displayNodes.forEach(function (entry) { entry.home.after(entry.node); entry.home.remove(); });
      placeholder.replaceChildren();
      placeholder.remove();
      background.remove();
      dialog.classList.remove('odg-style-ready', 'is-cart-pending');
      delete dialog.dataset.odgInitialized;
      unlockPage();
    }
    instances.set(product, dispose);
    // Keep the canonical hidden ID field able to represent a sold-out selection, too.
    var existingVariantIds = new Set(Array.from(selectors.variantIdField.options).map(function (option) { return option.value; }));
    data.variants.forEach(function (variant) {
      var id = String(variant.id);
      if (!existingVariantIds.has(id)) {
        selectors.variantIdField.add(new Option(variant.title, variant.id));
        existingVariantIds.add(id);
      }
    });
    var selectedId = selectors.variantIdField.value;
    var hasVariantLink = new URLSearchParams(window.location.search).has('variant');
    if (media.matches && !hasVariantLink) selectedId = String(data.variants[0].id);
    var selectedVariant = variantById.get(String(selectedId));
    if (media.matches && (!selectedVariant || !selectedVariant.available)) {
      var firstAvailableStyle = data.variants.find(function (variant) { return variant.available; });
      if (firstAvailableStyle) {
        selectedVariant = firstAvailableStyle;
        selectedId = String(firstAvailableStyle.id);
      }
    }
    if (media.matches && selectedVariant) selectors.selectVariant(selectedId, { initialLoad: !hasVariantLink });
    else if (selectedVariant) window.odgSyncStylePicker(product, selectedVariant);
  }
  document.addEventListener('odg:style-ready', function (event) { pruneDetached(); initialize(event.detail.product); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, product) {
      if (event.target === product || event.target.contains(product)) dispose();
    });
    pruneDetached();
  });
  function scan() { pruneDetached(); document.querySelectorAll('.js-product').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
